import Vue from 'vue'
import VueRouter from 'vue-router'
import Subscriptions from '../views/Subscriptions.vue'
import Users from '../views/Users.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/subscriptions' },
  {
    path: '/subscriptions',
    name: 'subscriptions',
    component: Subscriptions
  },
  {
    path: '/users',
    name: 'users',
    component: Users
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
